import { onMounted, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import {
  getBindUserFirstSelectionList,
  getBindUserSecondSelectionList,
  getBindUserThirdSelectionList,
} from '@/api/person.js'

export const useCascader = (modifyFlag, formData, searchWord) => {
  onMounted(async () => {
    cascaderOptions.value = await getFirstSelction()
  })

  const resultList = ref([])

  const store = useStore()
  const route = useRoute()

  const showCascader = ref(false)
  const cascaderValue = ref('')
  const cascaderOptions = ref([])
  const currentTab = ref(0)
  const currentId = ref('')

  const selectValue = ref([{}, {}, {}])

  const cascaderName = ref(store.getters.getModuleInfo?.name)
  let cascaderData = reactive({})
  const handleCasCaderClick = () => {
    if (!modifyFlag.value) {
      return
    }
    showCascader.value = true
  }

  watch(searchWord, async (n) => {

    if (currentTab.value === 0) {
      resultList.value = await getFirstSelction()
    }

    if (currentTab.value === 1) {
      const children = await getSelctionChildren(0, selectValue.value[0].id)
      resultList.value = children
    }
    if (currentTab.value === 2) {
      const children = await getSelctionChildren(1, selectValue.value[1].id)
      resultList.value = children
    }

  })

  // 切换tab
  const handleCasCaderTabClick  = (tabIndex) => {
    currentTab.value = tabIndex
  }

  const handleSearchItemClick = async (item) => {
    cascaderValue.value = item.id

    selectValue.value[item.level] = item

    searchWord.value = ''

    if (item.isChildren === 1) {
      const children = await getSelctionChildren(item.level, item.id)
      if (item.level === 0) {
        cascaderOptions.value.map(option => {
          if (option.id === item.id) {
            option.children = children
          }
        })
      } else if (item.level === 1) {
        cascaderOptions.value.filter(option => option.id === selectValue.value[0].id)[0].children.map(child => {
          if (child.id === item.id) {
            child.children = children
          }})
      }

    } else {
      onCascaderFinish({ selectedOptions: selectValue.value, tabIndex: item.level, value: item.id })
    }

    currentTab.value = item.level + 1
  }

  // 异步加载选项
  const handleCasCaderChange = async ({ selectedOptions, tabIndex, value }) => {
    currentTab.value = tabIndex + 1
    currentId.value = value
    // 加载第二级
    if (tabIndex === 0) {
      const children = await getSelctionChildren(tabIndex, value)
      if (children && children.length > 0) {
        selectedOptions[tabIndex].children = children
      }

    }
    // 加载第三级
    if (tabIndex === 1) {
      const children = await getSelctionChildren(tabIndex, value)
      if (children && children.length > 0) {
        selectedOptions[tabIndex].children = children
      }
    }

    return
  }

  // 级联选择
  const onCascaderFinish = ({value, selectedOptions, tabIndex }) => {

    selectValue.value = selectedOptions

    currentTab.value < 2 && (currentTab.value++)
    // 说明还有子级，还没完
    if (selectedOptions[tabIndex].isChildren === 1) {
      return
    }

    // 遍历选中的选项，给formData赋值，假如selectedOptions的长度不够，给他其他的赋值空
    cascaderData.firstId = selectedOptions[0]?.id || ''
    cascaderData.firstName = selectedOptions[0]?.name || ''
    formData.firstId = selectedOptions[0]?.id || ''
    formData.firstName = selectedOptions[0]?.name || ''

    cascaderData.secondId = selectedOptions[1]?.id || ''
    cascaderData.secondName = selectedOptions[1]?.name   || ''
    formData.secondId = selectedOptions[1]?.id || ''
    formData.secondName = selectedOptions[1]?.name  || ''

    cascaderData.thirdId = selectedOptions[2]?.id || ''
    cascaderData.thirdName = selectedOptions[2]?.name || ''
    formData.thirdId = selectedOptions[2]?.id || ''
    formData.thirdName = selectedOptions[2]?.name || ''

    formData.cascaderValue = selectedOptions.filter(item => item.name).map((option) => option.name)
      .join('/')
    showCascader.value = false
  }

  // 获取一级下的选项
  const getFirstSelction = async () => {
    let data = []

    const res = await getBindUserFirstSelectionList({
      typeId: store.getters.getModuleInfo?.typeId || route.query.typeId,
      orgId: store.getters.getOrgId,
      keyword: searchWord.value,
      pageNo: 1,
      pageSize: 999,
    })
    if (res.ok) {
      data = res.data?.rows || []
      // cascaderOptions.value = res.data.rows
    }
    data.forEach((item) => {
      item.level = 0
    })
    return data
  }
  // 获取二级下的选型
  const getSelctionChildren = async (level, id) => {
    let data = []
    const param = {
      pageNo: 1,
      pageSize: 999,
      keyword: searchWord.value,
      orgId: store.getters.getOrgId,
    }
    let func = getBindUserSecondSelectionList

    // 获取二级相关参数
    if (level === 0) {
      param.firstId = id
      func = getBindUserSecondSelectionList
    }
    // 获取三级相关参数
    if (level === 1) {
      param.secondId = id
      func = getBindUserThirdSelectionList
    }
    const res = await func(param)
    if (res.ok) {
      data = res.data.rows
    }

    data.forEach((item) => {
      item.level = level + 1
    })

    return data
  }

  return {
    resultList,
    cascaderName,
    showCascader,
    cascaderValue,
    cascaderOptions,
    cascaderData,
    onCascaderFinish,
    handleCasCaderClick,
    handleCasCaderTabClick,
    handleCasCaderChange,
    handleSearchItemClick
  }
}
